export const htmlTitle = {
  '/password': 'Initialisation du mot de passe',
  '/confirm': 'Confirmation de création de mot de passe',
};

export const title = {
  appTitle: 'Créez votre mot de passe',
  getCode: 'Recevez votre code d\'initialisation',
  password: 'Créez votre mot de passe',
  passwordIsSaved: 'Votre mot de passe a bien été enregistré !',
  codeExpired: 'Le code d\'initialisation a expiré',
};

export const url = {
  helpLabel: 'Comment initialiser le mot de passe de votre compte Orange',
};

export const caption = {
  yourAccount: 'Indiquez votre compte Orange',
  chooseContactWay: 'Choisissez le moyen de contact sur lequel vous souhaitez recevoir votre code d\'initialisation du mot de passe :',
  maxSmsCodeAttempts: 'Vous avez atteint le maximum d’envois du code d\'initialisation de mot de passe par SMS.<br>Nous vous invitons à renouveler votre demande ultérieurement.',
  maxMailCodeAttempts: 'Vous avez atteint le maximum d’envois du code d\'initialisation de mot de passe par email.<br>Nous vous invitons à renouveler votre demande ultérieurement.',
  receiveCode: 'Recevez votre code d\'initialisation',
  receiveCodeBySms: 'Votre code d\'initialisation du mot de passe vous sera envoyé par SMS au ',
  codeHelpingCreatePassword: 'Ce code vous servira à créer votre mot de passe.',
  otcSentBySms: 'Votre code d\'initialisation du mot de passe a été envoyé au ',
  otcSentByMail: 'Votre code d\'initialisation du mot de passe a été envoyé à ',
  updatingPassword: 'Création de votre mot de passe en cours...',
  codeWillBeSentBySms: 'Votre code d\'initialisation du mot de passe vous sera envoyé par SMS à ce numéro.<br>Ce code vous servira à créer votre mot de passe.',
  codeWillBeSentBySmsHidden: 'Votre code d\'initialisation du mot de passe vous sera envoyé par SMS à ce numéro.<br>Ce code vous servira à créer votre mot de passe.<br>Pour des raisons de sécurité, vos données de contact sont partiellement masquées.',
  codeWillBeSentByMail: 'Votre code d\'initialisation du mot de passe vous sera envoyé par email à cette adresse.',
  codeWillBeSentByMailHidden: 'Votre code d\'initialisation du mot de passe vous sera envoyé par email.<br>Pour des raisons de sécurité, vos données de contact sont partiellement masquées.',
  codeHelping: 'Ce code à 6 chiffres vous permet de créer votre mot de passe.',
  codeExpired: 'Le code d\'initialisation qui vous a été envoyé n’est plus valide.<br>Nous vous invitons à renouveler votre demande.',
  createNewPassword: 'Créez votre mot de passe',
  confirmNewPassword: 'Confirmez votre mot de passe',
};

export const errorMessage = {
  passwordEmpty: 'Veuillez saisir un mot de passe',
  noOtpInput: 'Veuillez saisir le code d\'initialisation.',
  otpIsNotANumber: 'Ce code d\'initialisation comporte uniquement des chiffres.',
  otpIsIncorrect: 'Veuillez vérifier la saisie de votre code d\'initialisation.',
};

export const hint = {
  fillLogin: 'Indiquez l\'adresse email ou le numéro de mobile du compte Orange dont vous souhaitez initialiser le mot de passe.',
  mailContact: 'Votre code d\'initialisation du mot de passe vous sera envoyé par email.<br>Pour des raisons de sécurité, votre email de contact peut être partiellement masqué.',
  mobileContact: 'Votre code d\'initialisation du mot de passe vous sera envoyé par SMS.<br>Pour des raisons de sécurité, votre numéro de mobile de contact peut être partiellement masqué.',
  multipleContacts: 'Choisissez le moyen de contact sur lequel vous souhaitez recevoir votre code d\'initialisation du mot de passe.<br>Pour des raisons de sécurité, vos moyens de contact peuvent être partiellement masqués.',
  step3: 'Ce code à 6 chiffres vous permet d\'initialiser votre mot de passe.',
};
